export const groupTypesSelector = state => state.groupTypes;
export const groupsSelector = state => state.groups;
export const topicsSelector = state => state.topics;
